export enum PageLayoutClassNameType {
  Default = 'default',
  NoPadding = 'no-padding',
  LegacyPadding = 'legacy-padding',
}
